Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _warning = require('./helpers/warning');

var _warning2 = _interopRequireDefault(_warning);

var _renderComponent = require('./helpers/renderComponent');

var _renderComponent2 = _interopRequireDefault(_renderComponent);

var _getIn = require('./helpers/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createState = function createState(_ref) {
  var value = _ref.value;
  return {
    value: value || '',
    touched: false,
    active: false,
    error: undefined,
    validating: false
  };
};

var Field = function (_React$Component) {
  _inherits(Field, _React$Component);

  function Field(props, context) {
    _classCallCheck(this, Field);

    var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

    _this.setActive = function (active) {
      _this.setState({ active: active });
    };

    _this.setValue = function (value) {
      _this.setState({ value: value });
    };

    _this.setError = function (error, validators) {
      _this.setState(function (prevState) {
        var newValidating = (prevState.validating || 0) + validators;

        if (newValidating <= 0) {
          newValidating = false;
        }

        return {
          error: error,
          validating: newValidating
        };
      });
    };

    _this.setTouched = function (touched) {
      _this.setState({ touched: touched });
    };

    _this.reset = function () {
      _this.setState(createState({
        value: (0, _getIn2['default'])(_this.context.formera.values, _this.props.name)
      }));
    };

    _this.handleFocus = function () {
      return _this.context.formera.handleFieldFocus(_this.field);
    };

    _this.handleOnChange = function (event) {
      var _event$target = event.target,
          type = _event$target.type,
          value = _event$target.value,
          checked = _event$target.checked;


      var val = /number|range/.test(type) ? parseFloat(value) : /checkbox/.test(type) ? checked : value;

      _this.context.formera.handleFieldChange(_this.field, val);
    };

    _this.handleBlur = function () {
      return _this.context.formera.handleFieldBlur(_this.field);
    };

    _this.field = {
      name: _this.props.name,
      reset: _this.reset,
      setActive: _this.setActive,
      setTouched: _this.setTouched,
      setValue: _this.setValue,
      setError: _this.setError
    };
    var formera = context.formera;


    (0, _warning2['default'])(formera, 'Field must be used inside of a Formera component');

    if (formera) {
      _this.state = createState({
        value: (0, _getIn2['default'])(formera.values, props.name)
      });

      formera.registerField(_this.field);
    }
    return _this;
  }

  _createClass(Field, [{
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return !(0, _fastDeepEqual2['default'])(nextState, this.state);
      }

      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        this.context.formera.unregisterField(this.field);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            name = _props.name,
            type = _props.type,
            propsValue = _props.value,
            props = _objectWithoutProperties(_props, ['name', 'type', 'value']);

        var _state = this.state,
            value = _state.value,
            rest = _objectWithoutProperties(_state, ['value']);

        var input = {
          onChange: this.handleOnChange,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          value: value,
          type: type
        };

        if (type === 'radio' || type === 'checkbox') {
          input.checked = value === propsValue || propsValue === undefined && value;
          input.value = propsValue;
        }

        // console.log(`%cRendering Field(${name})`, 'color: #0000ff;');
        return (0, _renderComponent2['default'])(_extends({}, props, { input: input, meta: _extends({}, rest) }), 'Field' + String(name));
      }

      return render;
    }()
  }]);

  return Field;
}(_react2['default'].Component);

Field.contextTypes = {
  formera: _propTypes2['default'].object
};


Field.propTypes = {
  render: _propTypes2['default'].func,
  children: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].node]),
  component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),

  // "config" props
  name: _propTypes2['default'].string.isRequired,
  type: _propTypes2['default'].string,
  value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool, _propTypes2['default'].number])
};

Field.defaultProps = {
  render: undefined,
  children: undefined,
  component: undefined,

  type: undefined,
  value: undefined
};

exports['default'] = Field;


//////////////////
// WEBPACK FOOTER
// ./node_modules/formera/lib/Field.js
// module id = 206
// module chunks = 0